<template>
  <DoRight
    ref="right"
    :reportId="reportId"
    :scantron="scantron"
    :answer="answer"
    :current="current"
    :allowPause="false"
    storeKey="homework-seconds"
    :hasNotSupport="false"
    shotAnswerEditable
    :submitTopicFunc="submitTopic"
    @getTopic="onGetTopic"
    @submit="onSubmit"
    :hideSetting="true"
  ></DoRight>
</template>
<script>
import DoRight from "@/components/ques/DoRight.vue";
export default {
  name: "HomeworkDoRight",
  components: {
    DoRight,
  },
  props: {
    reportId: {},
    scantron: {
      type: Object,
      default: () => {},
    },
    answer: {
      type: Object,
      default: () => {
        return {};
      },
    },
    answerImg: {
      type: Object,
      default: () => {
        return {};
      },
    },
    files: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: {},
    };
  },
  computed: {
    total() {
      return this.scantron.data.length;
    },
    answerCount() {
      return this.scantron.data.filter(q => q.status == 1 || q.status == 2)
        .length;
    },
  },
  methods: {
    init(index) {
      this.$refs.right.init(index);
    },
    async onGetTopic({ reportId, index }) {
      let data = await this.$http.post("/api/app/user/homework/question", {
        report_id: reportId,
        page: index,
      });
      let ques = data.data[0];
      if (ques.ques_type != 5 && typeof ques.ques_option === "string") {
        ques.ques_option = JSON.parse(ques.ques_option);
      }
      ques.question_id = ques.ques_id;
      ques.index = index;
      this.current = ques;
      this.$emit("topicChange", ques);
    },
    async submitTopic({
      report_id,
      question_id,
      user_answer,
      answer_time,
      question,
    }) {
      let attachments = [];
      if (question.ques_type == 5) {
        if (
          user_answer != "" ||
          (this.answerImg[question_id] &&
            this.answerImg[question_id].length > 0)
        ) {
          user_answer = JSON.stringify({
            content: user_answer,
            images: this.answerImg[question_id] || [],
          });
        }
        for (let item of this.files) {
          attachments.push({
            url: item.path,
            name: item.originalName,
          });
        }
      }
      await this.$http.post("/api/app/user/homework/storeQuestion", {
        report_id: report_id,
        question_id: question_id,
        user_answer: user_answer,
        answer_time: answer_time,
        attachments: JSON.stringify(attachments),
      });
    },
    async onSubmit({ id, answer_time, autoSubmit }) {
      await this.$http.post("/api/app/user/homework/storeReport", {
        report_id: id,
        answer_time: answer_time,
      });

      this.$emit("submit", { autoSubmit });
    },
    async navNext() {
      this.$refs.right.navNext();
    },
  },
};
</script>
